var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h2',{staticClass:"error"},[_vm._v("404")]),_c('p',{staticClass:"gone-fishing"},[_vm._v("We're having a reel-y hard time finding this page!")]),_c('BookNow')],1)}
var staticRenderFns = []

export { render, staticRenderFns }